import { browser } from '$app/environment';
import { PUBLIC_GA_ID } from '$env/static/public';

let analyticsInitialized = false;

export function initializeAnalytics() {
	if (!browser || !PUBLIC_GA_ID || analyticsInitialized) return;
	analyticsInitialized = true;

	// Load the gtag script
	const script = document.createElement('script');
	script.async = true;
	script.src = `https://www.googletagmanager.com/gtag/js?id=${PUBLIC_GA_ID}`;
	document.head.appendChild(script);

	// Initialize gtag
	window.dataLayer = window.dataLayer || [];
	// gtag.js recognizes a dataLayer entry as a gtag command only when it's the
	// native `arguments` object ([object Arguments]). It must be pushed as a
	// SINGLE entry — spreading the args, or pushing a plain array, breaks command
	// detection and events arrive mangled (e.g. "page_view" split into
	// character-indexed keys), so GA records nothing. This mirrors Google's
	// canonical bootstrap snippet: function gtag(){ dataLayer.push(arguments); }
	// eslint-disable-next-line prefer-rest-params
	window.gtag = function gtag() {
		// eslint-disable-next-line prefer-rest-params
		window.dataLayer.push(arguments as unknown as never);
	};

	window.gtag('js', new Date());
	window.gtag('config', PUBLIC_GA_ID, {
		send_page_view: false // We'll handle page views manually
	});
}

// Track page views
export function trackPageView(url: URL) {
	if (!browser || !window.gtag || !PUBLIC_GA_ID) return;
	window.gtag('event', 'page_view', {
		page_path: url.pathname,
		page_location: url.href,
		page_title: document.title
	});
}

// Track events
export function trackEvent(eventName: string, parameters: Record<string, unknown> = {}) {
	if (!browser || !window.gtag || !PUBLIC_GA_ID) return;
	window.gtag('event', eventName, parameters);
}

// Track GA4 purchase event for revenue reporting
export function trackPurchase(params: {
	transaction_id: string;
	value: number;
	item_name: string;
	creator_id: string;
	image_type?: string;
	voices_used?: string[];
}) {
	const eventParams: Record<string, unknown> = {
		transaction_id: params.transaction_id,
		value: params.value,
		currency: 'USD',
		item_name: params.item_name,
		creator_id: params.creator_id
	};
	if (params.image_type) {
		eventParams.image_type = params.image_type;
	}
	if (params.voices_used && params.voices_used.length > 0) {
		eventParams.voices_used = params.voices_used.join(',');
	}
	trackEvent('purchase', eventParams);
}
